import { useCallback, useEffect, useState } from "react";
import { Box, Typography, Paper, Table, TableHead, TableRow, TableCell, TableBody, Grid, TextField, Button } from "@mui/material";
import { useAuth } from "../../../context/AuthContext";
import { useProtectedRoute } from "../../../hooks/useProtectedRoute";
import { fetchProfitLoss } from "../../../services/accounting";

export default function ProfitLossPage() {
  useProtectedRoute();
  const { token } = useAuth();
  const [from, setFrom] = useState<string>(new Date(new Date().getFullYear(), new Date().getMonth(), 1).toISOString().slice(0,10));
  const [to, setTo] = useState<string>(new Date().toISOString().slice(0,10));
  const [data, setData] = useState<any>(null);

  const load = useCallback(async () => {
    try {
      const res = await fetchProfitLoss(token!, { from, to });
      setData(res);
    } catch (e) { console.error(e); }
  }, [token, from, to]);

  useEffect(() => { if (token) load(); }, [token, load]);

  return (
    <Box p={4}>
      <Typography variant="h5" fontWeight="bold" className="mb-4">Profit & Loss</Typography>
      <Grid container spacing={2} className="mb-3">
        <Grid item xs={12} sm={4}><TextField fullWidth type="date" label="From" value={from} onChange={e=>setFrom(e.target.value)} InputLabelProps={{ shrink: true }} /></Grid>
        <Grid item xs={12} sm={4}><TextField fullWidth type="date" label="To" value={to} onChange={e=>setTo(e.target.value)} InputLabelProps={{ shrink: true }} /></Grid>
        <Grid item xs={12} sm={4}><Button fullWidth variant="contained" onClick={load}>Run</Button></Grid>
      </Grid>
      {data && (
        <>
          <Paper className="mb-4 p-4">
            <Typography>Net Revenue: ${data.totals.netRevenue?.toFixed?.(2) ?? data.totals.netRevenue}</Typography>
            <Typography>COGS: ${data.totals.cogs?.toFixed?.(2) ?? data.totals.cogs}</Typography>
            <Typography>Gross Profit: ${data.totals.grossProfit?.toFixed?.(2) ?? data.totals.grossProfit}</Typography>
            <Typography>Expenses: ${data.totals.expenses?.toFixed?.(2) ?? data.totals.expenses}</Typography>
            <Typography variant="h6">Net Profit: ${data.totals.netProfit?.toFixed?.(2) ?? data.totals.netProfit}</Typography>
          </Paper>
          <Paper>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Account</TableCell>
                  <TableCell align="right">Debit</TableCell>
                  <TableCell align="right">Credit</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {Object.entries<any>(data.breakdown || {}).map(([acc, v]) => (
                  <TableRow key={acc}>
                    <TableCell>{acc}</TableCell>
                    <TableCell align="right">{Number(v.debit).toFixed(2)}</TableCell>
                    <TableCell align="right">{Number(v.credit).toFixed(2)}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </Paper>
        </>
      )}
    </Box>
  );
}
